/* =========================================================
   "이런 분들과 만듭니다" — 타깃 세그먼트 (문서 §2 표 원문 그대로)
   홈 · /partnership 카드 섹션과 개발 문의 폼(공동개발 문의)의 '업종' 선택지가 이 목록을 함께 쓴다.
   - 배열 순서대로 보인다. 아이디어상품 개발자 · 정부지원사업 선정 창업자를 맨 앞에 둔다
   - featured: true 인 항목이 홈에서 먼저 보이고, 나머지는 '더 보기'로 펼친다
   - link: 카드의 [개발 문의 하기] 목적지 (기본 /contact?segment=<id> — 공동개발 문의를 고르고 업종을 채운다)
   ========================================================= */

export const SEGMENTS = [
  {
    id: "idea",
    icon: "Lightbulb",
    label: "아이디어상품 개발자",
    who: "예비 창업자, 1인 브랜드, 크라우드펀딩 준비자",
    needs: ["펀딩용 동작 시제품", "양산 가능한 설계", "앱 연동", "소량 초도 생산"],
    featured: true,
  },
  {
    id: "funded",
    icon: "Award",
    label: "정부지원사업 선정 창업자",
    who: "창업패키지·아이디어 공모전·시제품 제작 지원사업 선정(예정)자",
    needs: [
      "지원금 예산 내 시제품 개발",
      "협약 기간 내 결과물 납품",
      "사업계획서 기술 파트·결과보고서 기술 자료 지원",
      "지원 종료 후 양산 연계",
    ],
    featured: true,
    link: "/funding",
  },
  {
    id: "workshop",
    icon: "Wrench",
    label: "개인공방 운영자",
    who: "목공·금속·가죽·도자·캔들·플라워 공방",
    needs: ["작업 공정 자동화 지그", "판매 상품에 조명·센서·움직임 추가", "체험 클래스용 키트"],
    featured: true,
  },
  {
    id: "artist",
    icon: "Motion",
    label: "예술작품 제작자",
    who: "설치미술·키네틱아트·미디어아트 작가",
    needs: ["모터·조명·센서 제어", "관람객 반응형 인터랙션", "전시 기간 무인 안정 동작", "원격 상태 확인"],
    featured: true,
  },
  {
    id: "sign",
    icon: "Bolt",
    label: "광고판·사인 제작업체",
    who: "간판·실내외 사인·POP·전시부스 제작사",
    needs: ["움직이는 사인", "센서 반응형 조명·콘텐츠", "원격 제어·스케줄링", "표준 컨트롤러 모듈"],
    featured: true,
  },
  {
    id: "store",
    icon: "Tablet",
    label: "매장·식음료 운영자",
    who: "식당·카페·소매점",
    needs: ["호출·주문·대기 안내 장치", "매장 연출 장치", "재고·환경 모니터링"],
  },
  {
    id: "farm",
    icon: "Sensor",
    label: "농장·체험장 운영자",
    who: "농가, 체험농장, 관광 체험시설",
    needs: ["환경 센서·원격 제어", "체험용 인터랙티브 장치"],
  },
  {
    id: "maker",
    icon: "Box",
    label: "소규모 제조·유통업체",
    who: "직원 10명 이하, 개발 인력 없음",
    needs: ["자사 제품의 전자화·IoT화", "생산 현장 보조 장치"],
  },
  {
    id: "edu",
    icon: "Doc",
    label: "교육·서비스업 운영자",
    who: "학원·교육업체·요양·돌봄 시설",
    needs: ["교구·실습 키트", "현장 보조·안전 장치"],
  },
];

/* 개발 문의 폼 '업종' 마지막 선택지 — 고르면 직접 입력 칸이 열린다 */
export const SEGMENT_OTHER = "기타(직접 입력)";

export function segmentLink(s) {
  return s.link || `/contact?segment=${s.id}`;
}
